import React from 'react';
import { cn } from '@/app/lib/utils';

interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className, width, height }) => {
  return (
    <div
      className={cn('animate-pulse bg-border rounded', className)}
      style={{
        width: width,
        height: height,
      }}
    />
  );
};

interface CardSkeletonProps {
  className?: string;
}

export const CardSkeleton: React.FC<CardSkeletonProps> = ({ className }) => {
  return (
    <div className={cn('bg-border rounded-lg border border-border', className)}>
      <div className="space-y-4">
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 bg-border rounded-full animate-pulse"></div>
            <div className="w-24 h-4 bg-border rounded animate-pulse"></div>
          </div>
          <div className="w-20 h-8 bg-border rounded animate-pulse"></div>
        </div>

        <div className="flex items-center justify-center py-8 rounded-md min-h-[200px] relative animate-pulse"></div>
      </div>
    </div>
  );
};
